// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as PersonOutlineComponent} from './PersonOutline.svg';

import Icon, { TIconProps } from '../Icon';

export const IconPersonOutline = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <PersonOutlineComponent/>
  </Icon>
));
